import { render } from "./BaseTopNavMobile.vue?vue&type=template&id=66c740c0&scoped=true"
import script from "./BaseTopNavMobile.vue?vue&type=script&lang=js"
export * from "./BaseTopNavMobile.vue?vue&type=script&lang=js"

import "./BaseTopNavMobile.vue?vue&type=style&index=0&id=66c740c0&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c740c0"]])

export default __exports__